export default Object.freeze({
  TITLE: 'e-mail 관리',
  TAB_ONE: 'e-mail 발송',
  TAB_TWO: 'e-mail 템플릿 설정',
  TAB_THREE: '자동e-mail 설정',
  TAB_FOUR: '자동e-mail 발송내역 조회',
  TAB_FIVE: '자동e-mail 사용내역 조회',
  DETAIL_ONE: 'ⓘ 광고성/정보성/자동 e-mail 발송 시 사용한 금액을 조회할 수 있습니다.',
  DETAIL_TWO: 'Ⓘ 매달 7일 이후에 전월의 사용량을 확인할 수 있습니다.',
  SEARCH_TITLE: '기간',
  YEAR: '년',
  MONTH: '월',
  TOP_TABLE: '총 사용금액 합계',
  BOTTOM_TABLE: '사용금액 상세',
  PRICE_POINT: '원',
  TABLE_HEADER_ONE: '기간',
  TABLE_HEADER_TWO: '사용량',
  TABLE_HEADER_THREE: '단가',
  TABLE_HEADER_FOUR: '금액',
});
